import { Component, OnInit, Inject, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-cobrador-x-dia',
  templateUrl: './cobrador-x-dia.component.html',
  styleUrls: ['./cobrador-x-dia.component.scss']
})
export class CobradorXDiaComponent implements OnInit, AfterViewInit, OnDestroy {

  // Variables DataTable //
  public dtOptions;
  public tableOpt = [];
  @ViewChild(DataTableDirective , {static: true}) tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  /**
   * Constructor
   * 
   * @param data 
   * @param {CarteraService} _cartera 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) public data, 
    private _cartera: CarteraService
  ) 
  {
    this.dtTrigger = new Subject();
    this.dtTrigger.next();

    this.dtOptions = {
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      columns: [
        {
          title: 'Nombre',
          data: 'nombre_completo'
        },
        {
          title: 'Cantidad Cobros',
          data: 'cant_cobros',
        }
      ]
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this._cartera.VerCobrosCobradorxDia(this.data.fecha).subscribe((data: any) => {
      this.tableOpt = data;
      this.renderer();
    });
  }

  /**
   * After View Init
   */
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Renderiza la tabla
   */
  public renderer(){
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    })
  }

  

}
